const report = {
  title: 'History',
  sections: 'Sections',
  noReports: 'No medical reports yet',
  noReportsDescription: 'Create your first medical report to get started.',
  noReportsSearch: 'No reports found for "{{searchQuery}}"',
  noReportsSearchDescription: 'Try a different search query.',
  createReport: 'Create Report',
  searchPlaceholder: 'Search reports...',
  section_one: '{{count}} section',
  section_other: '{{count}} sections',
  loading: 'Loading...',
  deleteConfirm: 'Are you sure you want to delete this medical report?',
  deleteConfirmTitle: 'Delete Report',
  deleteConfirmDescription:
    'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  delete: 'Delete',
  invalidReportId: 'Invalid report ID',
  reportNotFound: 'Report not found',
  patientName: 'Report Title',
  patientNamePlaceholder: 'Patient Name (Visit Reason)',
  addSection: 'Add Section',
  noSections: 'No sections yet. Add your first section to get started.',
  sectionTitle: 'Section Title',
  sectionTitlePlaceholder: 'Chief Complaint, Assessment',
  sectionContent: 'Section Content',
  sectionContentPlaceholder: 'Enter section content...',
  save: 'Save',
  cancel: 'Cancel',
  generateReport: 'Generate Report',
  reportGenerated: 'Report generated successfully',
  report: 'Report',
  downloadPdf: 'Download PDF',
  downloadDocx: 'Download DOCX',
  pdfPreview: 'PDF Preview',
  previewReport: 'Preview report',
  viewTranscription: 'View transcription',
  reportActions: 'Report actions',
  separator: ' • ',
  reportUpdated: 'Report updated',
  deletedSuccessfully: 'Report deleted successfully',
  download: 'Download',
  downloading: 'Downloading',
  regenerate: 'Regenerate document',
  regenerateDescription: 'Generate fresh PDF and Word files',
  saving: 'Saving…',
  generatingPreview: 'Updating preview…',
  saved: 'Changes saved',
  saveChangesFirst: 'Save your changes first',
  copyReport: 'Copy report',
  copyReportSuccess: 'Copied!',
  copyReportError: 'Could not copy report',
  status: {
    draft: 'Draft',
    recording: 'Recording',
    processing: 'Processing',
    generating: 'Generating',
    completed: 'Completed',
    prepared: 'Prepared',
    transcribing: 'Transcribing',
    error: 'Error',
  },
  validation: {
    patientNameRequired: 'Report title is required',
    atLeastOneSectionRequired: 'At least one section is required',
    sectionTitleRequired: 'Section title is required',
    sectionContentRequired: 'Section content is required',
  },
  reopenForRecording: 'Record again',
  reopenConfirmTitle: 'Reopen Report?',
  reopenConfirmDescription:
    'This will move the report back to draft. You can record additional audio and regenerate the document.',
  reopenConfirm: 'Reopen',

  customIntegrations:
    'For custom document templates and software integrations, contact us at ',

  errors: {
    notFound: 'Report not found',
    processingFailed: 'Processing failed',
    processingFailedDescription:
      'Something went wrong while processing this report. Please try again.',
    tryAgainLater: 'Please wait for a moment and try again later.',
    retry: 'Try again',
  },
};

export default report;
